import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Container, Stack, Typography, useTheme } from '@mui/material';

import ErrorIcon from '@/assets/icons/failed-red.svg?react';

const ErrorGeneric = () => {
  const { t } = useTranslation('common');
  const { palette } = useTheme();

  const handleReload = useCallback(() => {
    window.location.reload();
  }, []);

  return (
    <Container component="main" maxWidth="sm" sx={{ mt: 8, textAlign: 'center' }}>
      <Stack
        spacing={3}
        alignItems="center"
        sx={{
          '& .ErrorIcon-root': {
            width: 64,
            height: 64,
            color: palette.error.main
          }
        }}
      >
        <ErrorIcon className="ErrorIcon-root" />
        <Typography variant="h4" component="h1" gutterBottom>
          {t('error.generalMessage')}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {t('error.somethingWentWrong')}
        </Typography>
        <Button variant="contained" color="primary" onClick={handleReload}>
          {t('error.reload')}
        </Button>
      </Stack>
    </Container>
  );
};

export default ErrorGeneric;
